import React from 'react';
import { Link } from 'react-router-dom';

const EventCard = ({ event }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div style={styles.card}>
        <div style={styles.metaInfo}>
            <p><strong>{event.etype}</strong></p>
        </div>
      <div style={styles.cardHeader}>
        <Link to={`/event/${event.id}`} style={styles.titleLink}>
          <h3 style={styles.title}>{event.title}</h3>
        </Link>
        <span style={styles.eventType}>{event.event_type}</span>
      </div>
      
	<div style={styles.cardBody}>
	    
         
        <div style={styles.metaInfo}>
          <p><strong>Speaker:</strong> {event.speaker.first_name } { event.speaker.last_name}</p>
          <p><strong>Affiliation:</strong> {event.speaker.affiliation}</p>
          <p><strong>Event Start:</strong> {formatDate(event.start)}</p>
            <p><strong>Event End:</strong> {formatDate(event.end)}</p>
	    <p><strong>Location</strong> {event.location}</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  card: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '1.5rem',
    marginBottom: '1.5rem',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'box-shadow 0.3s ease',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '1rem',
  },
  titleLink: {
    textDecoration: 'none',
    color: '#2c3e50',
    flex: 1,
  },
  title: {
    margin: 0,
    fontSize: '1.5rem',
    cursor: 'pointer',
  },
  eventType: {
    backgroundColor: '#3498db',
    color: 'white',
    padding: '0.25rem 0.75rem',
    borderRadius: '20px',
    fontSize: '0.875rem',
    marginLeft: '1rem',
  },
  cardBody: {
    lineHeight: '1.6',
  },
  description: {
    color: '#555',
    marginBottom: '1rem',
  },
  metaInfo: {
    fontSize: '0.9rem',
    color: '#666',
  },
};

export default EventCard;
